<cc-box>

    <div class="lg-container"
         [formGroup]="form"
         header
         box>
      <span translate>LEAD_GENERATION.SETTINGS.WORKING_HOURS</span>
      <ui-switch class="pull-right custom" formControlName="enabled"></ui-switch>
    </div>

  <div  content
        box>

    <div class="lg-container-with-button b-b" *ngIf="workingHoursAreEnabled">
      <div class="flex-between align-item-center" layout>
        <label translate>LEAD_GENERATION.SETTINGS.USE_TIME_ZONE</label>
        <cc-timezones-dropdown
          ngDefaultControl
          class="w-45"
          [initial]="work.timezone"
          [formControl]="form.get('timezone')"
        ></cc-timezones-dropdown>
      </div>
    </div>

    <section *ngIf="workingHoursAreEnabled">
      <div
        class="lg-container l-h-2">
        <div class="justify-content-space-between working-hours-box flex-column" layout>
          <label class="display-when m-b-sm" translate>{{ displayTitle }}</label>
          <div
            *ngFor="let range of ranges.controls; let isLast = last; let i=index"
            [ngClass]="{'m-b-md p-b-md b-b': !isLast}">

            <cc-lg-working-hours-range
              [range]="range"
              (selectionChange)="onSelectionChanged($event)"
              (deleteClicked)="deleteRange(i)"
              [deleteEnabled]="ranges.length > 1"
              [disabledDays]="disabledDays"
            >
            </cc-lg-working-hours-range>
          </div>
          <a class="link"
             *ngIf="!allDaysAreDisabled"
             (click)="createNewRange()" translate>LEAD_GENERATION.SETTINGS.ADD_ANOTHER</a>
        </div>
      </div>
    </section>

  </div>
</cc-box>
